<template>
  <div>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div
      class="relative bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8"
    >
      <div class="absolute inset-0">
        <div class="bg-white h-1/3 sm:h-2/3"></div>
      </div>
      <div class="relative max-w-7xl mx-auto">
        <div class="text-center">
          <h2
            class="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl"
          >
            Homes for sale
          </h2>
          <p class="mt-3 max-w-2xl mx-auto text-base text-gray-500 sm:mt-4">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa
            libero labore natus atque
          </p>
        </div>
        <!-- <div class="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5"> -->

        <div class="grid gap-5 lg:grid-cols-3 lg:max-w-none">
          <div
            v-for="rental in idx"
            :key="rental.id"
            class="rounded-lg shadow flex flex-col overflow-hidden"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card color="grey lighten-4">
                <v-img :aspect-ratio="16 / 9" :src="rental.Images[0]">
                  <v-expand-transition>
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                      style="height: 100%; opacity: .7"
                    >
                      <v-btn depressed :href="rental.rental_application_path">
                        Request Showing!
                      </v-btn>
                    </div>
                  </v-expand-transition>
                </v-img>

                <v-card-text>
                  <v-btn
                    absolute
                    color="blue"
                    class="white--text"
                    style="margin-top: 3em"
                    fab
                    large
                    right
                    top
                    @click="singleView(rental)"
                  >
                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                  </v-btn>
                  <div class="font-weight-light grey--text title mb-2">
                    {{ rental.City }}<br />
                    List Price: {{ rental.ListPrice }}
                  </div>

                  <h3 class="display-1 font-weight-light blue--text mb-2">
                    {{ rental.StreetNumber }}
                    {{ rental.StreetName }}
                    {{ rental.StreetSuffix }}
                  </h3>
                  <v-divider></v-divider>
                  <div class="mt-4">
                    <v-chip class="mr-2">
                      <v-icon left> mdi-brightness-5 </v-icon>
                      Lot size: {{ rental.LotSizeAcresRange }}
                    </v-chip>

                    <v-chip class="mr-2">
                      <v-icon left> mdi-brightness-5 </v-icon>
                      Bathroom: {{ rental.BathroomsFull }}
                    </v-chip>

                    <v-chip class="mr-2">
                      <v-icon left> mdi-brightness-5 </v-icon>
                      Bedroom: {{ rental.BedroomsTotal }}
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-hover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
export default {
  data() {
    return {
      idx: []
    };
  },
  created() {
    this.idxFeed();
  },

  methods: {
    idxFeed() {
      window.axios.get("/api/retsApi").then(response => {
        this.idx = response.data;
      });
    },

    singleView(rental) {
      this.$router.push({
        name: "SingleIDX",
        params: { id: rental.ListingKeyNumeric, rental }
      });
    }
  }
};
</script>

<style scoped lang="scss">
#p-remove {
  height: 4em;
}

@media (max-width: 1026px) {
  #p-remove {
    height: 6em;
  }
}

.modal .modal-dialog {
  width: 100%;
  height: 100%;
  max-width: 95%;
  min-height: 100vh;
}

.c-card {
  img {
    transition: transform 0.3s ease-in-out;
  }

  &:hover {
    img {
      transform: scale(1.05);
    }
  }
}
</style>
